<template>
  <div>
    <TopHeader code="train" />

    <section class="container-fluid uc-bg2">
      <div class="container">
        <div class="row">
          <div class="col-24">
            <div class="uc-crumb">
              <router-link to="/" class="item">首页</router-link>
              <router-link :to="{ name: 'TrainClass' }" class="item"
                >专题</router-link
              >
              <router-link to="" class="item">专题详情</router-link>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-24">
            <section class="uc-CultivateDetailBox">
              <div class="banner-box">
                <img src="../../assets/images/banner-train.png" />
                <div class="txt">{{ model.name }}</div>
              </div>
              <div class="btm">
                <div class="left">
                  <div class="info">
                    <div class="item">
                      报名日期：
                      {{
                        model.is_open && model.is_need_sign_up
                          ? model.sign_up_start_time +
                            ' ~ ' +
                            model.sign_up_end_time
                          : '不需要报名'
                      }}
                    </div>
                    <div class="item">
                      培训日期：{{ model.train_start_time }} ~
                      {{ model.train_end_time }}
                    </div>
                    <div class="item">
                      培训人数：
                      {{
                        model.plan_people_number
                          ? model.plan_people_number + '人'
                          : '不限人数'
                      }}
                    </div>
                    <div class="item">
                      培训对象：{{
                        model.train_object ? model.train_object : '--'
                      }}
                    </div>
                    <div class="item">
                      必 / 选修：
                      {{ model.is_required ? '必修' : '选修' }}
                    </div>
                    <div
                      class="item"
                      v-if="model.is_open_topic && model.topic_id > 0"
                    >
                      培训话题：
                      <router-link
                        :to="{
                          name: 'TopicDetails',
                          params: { id: model.topic_id },
                        }"
                        target="_blank"
                      >
                        参与讨论>>
                      </router-link>
                    </div>
                    <div class="item">
                      <i class="el-icon-set-up"></i>
                      <span
                        v-html="
                          model.cert_tpl_id == 0
                            ? '无证书'
                            : model.certificate == null
                            ? '未获得证书'
                            : `<a href='${model.certificate.cert_url}' target=_blank>查看证书</a>`
                        "
                      >
                      </span>
                    </div>
                  </div>
                  <div class="intro">
                    <span class="txt">介绍：</span>
                    {{ model.train_content || '无' }}
                  </div>

                  <div
                    class="operate"
                    v-if="
                      model.approval_status == 1 &&
                      (model.exam_paper || model.questionnaire)
                    "
                  >
                    <template v-if="model.exam_paper">
                      <router-link
                        v-if="
                          model.exam_paper.allow_times === 0 ||
                          model.exam_paper.allow_times >
                            model.exam_paper.answer_times
                        "
                        to=""
                        class="uc-btn black"
                        @click.native="handleTrainExamClick(model)"
                      >
                        培训考试 <i class="uc-font uc-next"></i>
                      </router-link>
                      <span
                        v-if="model.exam_paper.exam_status == 1"
                        class="uc-phColor uc-pr30"
                        :class="
                          model.exam_paper.is_pass
                            ? 'el-icon-check'
                            : 'el-icon-close'
                        "
                      >
                        考试成绩：{{ model.exam_paper.user_score }}分</span
                      >
                    </template>
                    <template v-if="model.questionnaire">
                      <router-link
                        v-if="model.questionnaire.answer_status != 1"
                        to=""
                        class="uc-btn black"
                        @click.native="handleTrainQstClick(model)"
                      >
                        培训问卷 <i class="uc-font uc-next"></i>
                      </router-link>
                      <span
                        v-if="model.questionnaire.answer_status == 1"
                        class="uc-phColor uc-pr30 el-icon-check"
                      >
                        培训问卷已经作答</span
                      >
                    </template>
                  </div>
                  <div
                    class="operate"
                    v-if="complete && model.approval_status != 1"
                  >
                    <router-link
                      to=""
                      class="uc-btn black"
                      v-if="model.approval_status == null"
                      @click.native="handleSignUp"
                    >
                      立即报名 <i class="uc-font uc-next"></i>
                    </router-link>
                    <router-link
                      to=""
                      class="uc-btn gray"
                      v-if="model.approval_status == 0"
                    >
                      待审核
                    </router-link>
                    <router-link
                      to=""
                      class="uc-btn red"
                      v-if="model.approval_status == 2"
                    >
                      审核驳回
                    </router-link>
                    <span
                      class="uc-phColor uc-pr30"
                      v-if="model.approval_status == 2"
                    >
                      驳回原因：{{ model.approval_reason }}
                    </span>
                  </div>
                </div>
                <div
                  class="code"
                  v-if="model.approval_status == 1 && model.we_chat_qr_code_img"
                >
                  <img :src="model.we_chat_qr_code_img" />
                  <p>扫码进交流群</p>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </section>

    <section class="container-fluid uc-bg2" v-if="model.approval_status == 1">
      <div class="container">
        <div class="row" v-if="model.stages.length > 1">
          <div class="col-24">
            <section class="uc-CultivateDetailFilter">
              <a
                href="javascript:;"
                class="item"
                v-for="(item, index) in model.stages"
                :key="index"
                :class="index == model.stage_index ? 'on' : ''"
                :style="
                  !item.is_can_learn ? 'color:grey; cursor:not-allowed;' : ''
                "
                :title="item.name"
                @click="handleStageChange(index, item.is_can_learn)"
                >{{ item.name }}</a
              >
            </section>
          </div>
        </div>
      </div>
    </section>

    <section class="container-fluid uc-bg uc-pt35 uc-pb40">
      <div class="container">
        <div class="row">
          <div
            class="col-24 col-sm-6"
            v-if="
              model.stages.length > 0 &&
              model.stages[model.stage_index].types.length > 1
            "
          >
            <section class="uc-CultivateDetailSideMenu uc-mr10">
              <div
                class="item"
                v-for="(item, index) in model.stages[model.stage_index].types"
                :key="index"
                :class="
                  item.type == model.stages[model.stage_index].type_index
                    ? 'on'
                    : ''
                "
                @click="model.stages[model.stage_index].type_index = item.type"
              >
                {{ item.type_name }}
              </div>
            </section>
          </div>

          <div
            class="col-24"
            :class="
              model.stages[model.stage_index].types.length > 1
                ? 'col-sm-18'
                : 'col-sm-24'
            "
            v-if="model.stages.length > 0"
          >
            <div
              v-for="(item, index) in model.stages[model.stage_index].types"
              :key="index"
              v-show="item.type == model.stages[model.stage_index].type_index"
            >
              <div v-if="item.type == 1">
                <div class="uc-CultivateDetailTotal">
                  当前共有 <b>{{ item.relations.length }}</b> 门课程
                </div>
                <section class="row g-list list style-radius">
                  <div
                    :class="
                      model.stages[model.stage_index].types.length > 1
                        ? 'col-8'
                        : 'col-6'
                    "
                    v-for="(item2, index2) in item.relations"
                    :key="index2"
                  >
                    <div class="item">
                      <router-link
                        :to="{
                          name: 'CourseDetails',
                          params: { id: item2.id },
                          query: {
                            from: 'trainStage',
                            fromId: query2.stageId,
                            isRequired: model.is_required,
                          },
                        }"
                        class="con"
                        target="_blank"
                      >
                        <div class="img-box">
                          <el-image :src="item2.cover">
                            <div slot="error" class="image-slot">
                              <img src="../../assets/images/default-kc.png" />
                            </div>
                          </el-image>
                        </div>
                        <div class="btm">
                          <h3>{{ item2.name }}</h3>
                          <div class="txt">
                            {{ item2.lecturer_name || '无讲师' }}
                            | {{ item2.period }}分钟
                          </div>
                        </div>
                      </router-link>
                    </div>
                  </div>
                </section>
              </div>
              <div v-if="item.type == 2">
                <div class="uc-CultivateDetailTotal">
                  当前共有 <b>{{ item.relations.length }}</b> 门课程
                </div>
                <section class="uc-CultivateDetailCourse">
                  <div
                    v-for="(item2, index2) in item.relations"
                    :key="index2"
                    class="item"
                  >
                    <div class="title">
                      <div class="c">{{ item2.name }}</div>
                    </div>
                    <div class="con">
                      <div class="sub-item">
                        讲师：{{ item2.lecturer_name || '无讲师' }}
                      </div>
                      <div class="sub-item">课时：{{ item2.period }}分钟</div>
                      <div class="sub-item">
                        培训地点：{{ item2.train_address }}
                      </div>
                      <div class="sub-item">
                        培训时间：{{ item2.train_start_time }} ~
                        {{ item2.train_end_time }}
                      </div>
                    </div>
                  </div>
                </section>
              </div>
              <div v-if="item.type == 3">
                <div class="uc-CultivateDetailTotal">
                  当前共有 <b>{{ item.relations.length }}</b> 个直播
                </div>
                <section class="row g-list list style-radius">
                  <div
                    :class="
                      model.stages[model.stage_index].types.length > 1
                        ? 'col-8'
                        : 'col-6'
                    "
                    v-for="(item2, index2) in item.relations"
                    :key="index2"
                  >
                    <div class="item">
                      <router-link
                        :to="{
                          name: 'LiveDetails',
                          params: { id: item2.id },
                          query: { from: 'trainStage', fromId: query2.stageId },
                        }"
                        class="con"
                        target="_blank"
                      >
                        <div class="img-box">
                          <el-image :src="item2.cover">
                            <div slot="error" class="image-slot">
                              <img src="../../assets/images/default-zb.png" />
                            </div>
                          </el-image>
                        </div>
                        <div class="btm">
                          <h3>{{ item2.name }}</h3>
                          <div class="txt">
                            {{ item2.anchor_name }}
                            | {{ item2.start_time }}
                          </div>
                        </div>
                      </router-link>
                    </div>
                  </div>
                </section>
              </div>
              <div v-if="item.type == 4" class="uc-examList">
                <div class="uc-CultivateDetailTotal">
                  当前共有 <b>{{ item.relations.length }}</b> 个考试
                </div>
                <div
                  v-for="(item2, index2) in item.relations"
                  :key="index2"
                  class="item"
                >
                  <router-link
                    to=""
                    class="title"
                    @click.native="handleExamClick(item2)"
                  >
                    <img
                      src="../../assets/images/icon130.png"
                      class="uc-icon20"
                      v-if="item2.exam_status == 0"
                    />
                    <img
                      src="../../assets/images/icon131.png"
                      class="uc-icon20"
                      v-if="item2.exam_status == 1 && item2.is_pass == 0"
                    />
                    <img
                      src="../../assets/images/icon132.png"
                      class="uc-icon20"
                      v-if="item2.exam_status == 1 && item2.is_pass == 1"
                    />
                    <img
                      src="../../assets/images/icon133.png"
                      class="uc-icon20"
                      v-if="item2.exam_status == 2"
                    />
                    <div class="c">
                      {{ item2.name
                      }}<span v-if="item2.user_score" class="uc-phColor"
                        >（{{ item2.user_score }}分）</span
                      >
                    </div>
                    <span class="uc-font uc-next"></span>
                  </router-link>
                  <div class="con">
                    <!-- <div class="sub-item">开始时间：{{ item2.start_time }}</div>
                    <div class="sub-item">结束时间：{{ item2.end_time }}</div> -->
                    <div class="sub-item">
                      试卷总分：{{ item2.total_score }}分
                    </div>
                    <div class="sub-item">
                      通过分数：{{ item2.pass_score }}分
                    </div>
                    <div class="sub-item">
                      考试时长：{{
                        item2.duration == 0 ? '不限' : item2.duration + '分钟'
                      }}
                    </div>
                    <div class="sub-item">
                      出题方式：{{ item2.question_way == 1 ? '随机' : '固定' }}
                    </div>
                    <div class="sub-item">
                      评分方式：{{ (item2.score_way = 1 ? '自动' : '手工') }}
                    </div>
                    <div class="sub-item">
                      可考次数：{{
                        item2.allow_times == 0
                          ? '不限'
                          : item2.allow_times + '次'
                      }}
                    </div>
                    <!-- <div class="sub-item">
                      出卷人员：{{ item2.create_first_name }}
                    </div> -->
                  </div>
                  <div
                    class="operate"
                    v-if="item2.exam_status == 1 && item2.config > 0"
                  >
                    <router-link
                      :to="{
                        name: 'ExamStatistics',
                        params: { id: item2.answer_id },
                      }"
                      target="_blank"
                      class="uc-btn blue-plain"
                      hover-class="none"
                      v-if="(item2.config & 2) == 2"
                      >查看分数</router-link
                    >
                    <router-link
                      :to="{
                        name: 'ExamWrong',
                        params: { id: item2.answer_id },
                      }"
                      target="_blank"
                      class="uc-btn blue-plain"
                      hover-class="none"
                      v-if="(item2.config & 8) == 8"
                      >查看错题</router-link
                    >
                    <router-link
                      :to="{
                        name: 'ExamRecord',
                        params: { id: item2.answer_id },
                      }"
                      target="_blank"
                      class="uc-btn blue-plain"
                      hover-class="none"
                      v-if="(item2.config & 1) == 1"
                      >查看答案</router-link
                    >
                    <router-link
                      :to="{ name: 'ExamRanking', params: { id: item2.id } }"
                      target="_blank"
                      class="uc-btn blue-plain"
                      hover-class="none"
                      v-if="(item2.config & 4) == 4"
                      >查看排名</router-link
                    >
                  </div>
                </div>
              </div>
              <div v-if="item.type == 5">
                <div class="uc-CultivateDetailTotal">
                  当前共有 <b>{{ item.relations.length }}</b> 个调查
                </div>
                <section class="uc-CultivateDetailQuestionnaire">
                  <div
                    v-for="(item2, index2) in item.relations"
                    :key="index2"
                    class="item"
                  >
                    <router-link to class="img-box">
                      <el-image :src="item2.cover">
                        <div slot="error" class="image-slot">
                          <img src="../../assets/images/default-qst.png" />
                        </div>
                      </el-image>
                    </router-link>
                    <div class="center">
                      <h3>{{ item2.name }}</h3>
                      <div class="con">
                        <!-- <div class="sub-item">
                          {{ item2.start_time }} ~ {{ item2.end_time }}
                        </div> -->
                        <div class="sub-item uc-pt40">
                          {{ item2.description }}
                        </div>
                      </div>
                      <div class="operate">
                        <div v-if="item2.qst_status == 0">
                          <a href="javascript:;" class="uc-btn green">未开始</a>
                        </div>
                        <div v-else-if="item2.qst_status == 1">
                          <div
                            v-if="
                              item2.answer_status == 0 ||
                              item2.answer_status == 2
                            "
                          >
                            <router-link
                              :to="{
                                name: 'QuestionnaireAnswer',
                                params: { id: item2.id },
                                query: {
                                  from: 'trainStage',
                                  fromId: query2.stageId,
                                },
                              }"
                              class="uc-btn"
                              target="_blank"
                            >
                              参与调查 <i class="uc-font uc-next"></i>
                            </router-link>
                          </div>
                          <div v-else>
                            <a href="javascript:;" class="uc-btn green"
                              >已作答</a
                            >
                          </div>
                        </div>
                        <div v-else>
                          <div
                            v-if="
                              item2.answer_status == 0 ||
                              item2.answer_status == 2
                            "
                          >
                            <a href="javascript:;" class="uc-btn green"
                              >已结束</a
                            >
                          </div>
                          <div v-else>
                            <a href="javascript:;" class="uc-btn green"
                              >已作答</a
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
              <div v-if="item.type == 6" class="g-list">
                <div
                  v-for="(item2, index2) in item.relations"
                  :key="index2"
                  class="item"
                >
                  <router-link
                    :to="{
                      name: 'KnowledgeDetails',
                      params: { id: item2.id },
                    }"
                    class="con"
                    target="_blank"
                  >
                    <div class="img-box">
                      <el-image :src="item2.cover">
                        <div slot="error" class="image-slot">
                          <img src="../../assets/images/default-zs.png" />
                        </div>
                      </el-image>
                    </div>
                    <div class="btm">
                      <el-tooltip
                        placement="top"
                        effect="light"
                        :content="item2.name"
                      >
                        <h3>{{ item2.name }}</h3>
                      </el-tooltip>
                      <div class="txt">{{ item2.create_time }}</div>
                    </div>
                  </router-link>
                </div>
              </div>
              <div v-if="item.type == 9">
                <div v-for="(item2, index2) in item.relations" :key="index2">
                  <section class="uc-CultivateDetailAssignment">
                    <img
                      src="../../assets/images/tag-read.png"
                      class="tag"
                      v-if="item2.approval_status == 1"
                    />
                    <div class="box box1">
                      <div class="left">
                        <h2>作业内容：</h2>
                        <div class="con">{{ item2.name }}</div>
                        <div class="con">{{ item2.content }}</div>
                      </div>
                      <div v-if="item2.file_path" class="right">
                        <a
                          :href="item2.file_path"
                          class="btn-down"
                          target="_blank"
                        >
                          <img
                            src="../../assets/images/icon-file.png"
                            class="uc-icon48"
                          />附件下载
                        </a>
                      </div>
                    </div>
                    <div class="line"></div>
                    <div class="box box2">
                      <h2>我的作业</h2>
                      <div class="text" v-show="!item2.edit">
                        {{ item2.answer_content }}
                      </div>
                      <p
                        class="tRight"
                        v-if="item2.approval_status != 1"
                        v-show="!item2.edit"
                      >
                        <router-link
                          to
                          class="uc-ml30"
                          @click.native="item2.edit = true"
                        >
                          <el-tooltip content="编辑" placement="top">
                            <i class="el-icon-edit"></i>
                          </el-tooltip>
                        </router-link>
                        <router-link
                          to
                          class="uc-ml30"
                          @click.native="delHomework(item2)"
                        >
                          <el-tooltip content="删除" placement="top">
                            <i class="el-icon-delete"></i>
                          </el-tooltip>
                        </router-link>
                      </p>
                      <textarea
                        class="uc-textarea"
                        placeholder="请输入作业内容"
                        cols="30"
                        rows="10"
                        v-model.trim="item2.answer_content2"
                        v-if="item2.approval_status != 1"
                        v-show="item2.edit"
                      ></textarea>
                      <div v-if="item2.answer_file_path" class="c">
                        <a
                          :href="item2.answer_file_path"
                          class="uc-blue"
                          target="_blank"
                          >查看上传作业</a
                        >
                      </div>
                      <div
                        class="operate"
                        v-if="item2.approval_status != 1"
                        v-show="item2.edit"
                      >
                        <el-upload
                          action=""
                          class="uc-btn blue btn-upload"
                          :file-list="item2.fileList"
                          :auto-upload="false"
                          :on-change="
                            (file, fileList) =>
                              changeUpload(item2, file, fileList)
                          "
                        >
                          <img
                            src="../../assets/images/upload-white.png"
                            class="uc-icon20"
                          />上传作业
                        </el-upload>
                        <a
                          href="javascript:;;"
                          class="uc-btn cancle"
                          v-if="item2.answer_id != null"
                          @click="item2.edit = false"
                          >取消</a
                        >
                        <a
                          href="javascript:;;"
                          class="uc-btn blue"
                          @click="submitHomework(item2)"
                          >交作业</a
                        >
                      </div>
                    </div>
                  </section>
                  <br v-if="index2 < item.relations.length - 1" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <BottomFooter />
  </div>
</template>

<script>
import TopHeader from '@/components/TopHeader.vue';
import BottomFooter from '@/components/BottomFooter.vue';

export default {
  name: 'TrainClassDetails',
  components: {
    TopHeader,
    BottomFooter,
  },
  data() {
    return {
      query: {
        id: this.$route.params.id,
      },
      query2: {
        classId: this.$route.params.id,
        stageId: 0,
      },
      model: {
        stages: [{ types: [] }],
        stage_index: 0,
      },
      complete: false,
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    async loadData() {
      await this.getTrainClassDetails();
      await this.getTrainStageRelationTypes();
      this.complete = true;
    },
    async getTrainClassDetails() {
      const response = await this.$api.train.getTrainClassDetails(this.query);
      const data = response.data.data;
      for (const item of data.stages) {
        item.types = [];
        item.type_index = 0;
      }
      data.stage_index = 0;
      this.model = data;
    },
    async getTrainStageRelationTypes() {
      if (this.model.stages.length > 0) {
        this.query2.stageId = this.model.stages[this.model.stage_index].id;
        const response = await this.$api.train.getTrainStageRelationTypes(
          this.query2
        );
        const data = response.data.data;
        for (const item of data) {
          if (item.type === 9) {
            for (const item2 of item.relations) {
              item2.fileList = [];
              item2.answer_content2 = item2.answer_content;
              item2.edit = item2.answer_id === null;
            }
          }
        }
        this.model.stages[this.model.stage_index].types = data;
        this.model.stages[this.model.stage_index].type_index = data[0].type;
      }
    },
    // 专题报名
    handleSignUp() {
      this.$confirm(`确定要报名【${this.model.name}】专题吗？`, '提示', {
        type: 'info',
      }).then(() => {
        this.$api.train
          .handleSignUp(this.query)
          .then((response) => {
            if (response.data.code === 200) {
              this.model.approval_status = 0;
              this.$message.success(response.data.message);
            } else {
              this.$message.warning(response.data.message);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      });
    },
    // 切换阶段
    handleStageChange(index, is_can_learn) {
      if (!is_can_learn) {
        this.$message({ message: '请按顺序学习' });
      } else if (this.model.stage_index !== index) {
        this.model.stage_index = index;
        this.getTrainStageRelationTypes();
      }
    },
    // 专题问卷
    handleTrainQstClick(item) {
      switch (item.questionnaire.answer_status) {
        case 1:
          this.$message({ message: '问卷已完成' });
          break;
        default:
          this.$confirm(
            `确定要参加【${item.questionnaire.name}】问卷吗？`,
            '提示',
            {
              type: 'info',
            }
          ).then(() => {
            window.open(
              `/questionnaire/answer/${item.qst_id}?from=trainClass&fromId=${this.query.id}`,
              'QstAnswer'
            );
          });
          break;
      }
    },
    // 专题考试
    handleTrainExamClick(item) {
      switch (item.exam_paper.paper_status) {
        case 0:
          this.$message({ message: '考试未开始' });
          break;
        case 1:
          // 可考次数不限 或 可考次数大于已考次数 才可以进入考试
          if (
            item.exam_paper.allow_times === 0 ||
            item.exam_paper.allow_times > item.exam_paper.answer_times
          ) {
            this.$confirm(
              `确定要参加【${item.exam_paper.name}】考试吗？`,
              '提示',
              {
                type: 'info',
              }
            ).then(() => {
              window.open(
                `/exam/answer/${item.exam_id}?from=trainClass&fromId=${this.query.id}`,
                'ExamAnswer'
              );
            });
          } else {
            this.$message.warning({ message: '考试次数超出限制' });
          }
          break;
        case 2:
          this.$message.warning({ message: '考试已结束' });
          break;
      }
    },
    // 专题阶段考试跳转
    handleExamClick(item) {
      switch (item.paper_status) {
        case 0:
          this.$message.warning({ message: '考试未开始' });
          break;
        case 1:
          // 可考次数不限 或 可考次数大于已考次数 才可以进入考试
          if (item.allow_times === 0 || item.allow_times > item.answer_times) {
            this.$confirm(`确定要参加【${item.name}】考试吗？`, '提示', {
              type: 'info',
            }).then(() => {
              window.open(
                `/exam/answer/${item.id}?from=trainStage&fromId=${this.query2.stageId}`,
                'ExamAnswer'
              );
            });
          } else {
            this.$message.warning({ message: '考试次数超出限制' });
          }
          break;
        case 2:
          this.$message.warning({ message: '考试已结束' });
          break;
      }
    },
    // 交作业
    submitHomework(item) {
      if (!item.answer_content2) {
        this.$message.warning({ message: '请输入作业内容' });
        return;
      }
      const formData = new FormData();
      formData.append('trainStageId', this.query2.stageId);
      formData.append('homeworkId', item.id);
      formData.append('content', item.answer_content2);
      if (item.fileList.length > 0) {
        formData.append('file', item.fileList[0].raw);
      }
      this.$api.train
        .submitHomework(formData)
        .then((response) => {
          const { code, message, data } = response.data;
          if (code === 200) {
            item.answer_id = data.id;
            item.answer_file_path = data.url;
            item.answer_content = item.answer_content2;
            item.approval_status = 0;
            item.fileList = [];
            item.edit = false;
            this.$message.success(message);
          } else {
            this.$message.warning(message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 上传文件选择
    changeUpload(item, file, fileList) {
      if (file.size > 100 * 1024 * 1024) {
        this.$message.error('上传文件大小不能超过 100MB!');
        return false;
      }
      if (fileList.length > 0) {
        item.fileList = [fileList[fileList.length - 1]];
      }
    },
    // 删除作业
    delHomework(item) {
      this.$confirm(`确定要删除吗？`, '提示', {
        type: 'info',
      }).then(() => {
        this.$api.train
          .delHomework({
            id: item.answer_id,
          })
          .then((response) => {
            if (response.data.code === 200) {
              item.answer_id = null;
              item.answer_content = null;
              item.answer_content2 = null;
              item.answer_file_path = null;
              item.approval_status = 0;
              item.fileList = [];
              item.edit = true;
              this.$message.success(response.data.message);
            } else {
              this.$message.warning(response.data.message);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      });
    },
  },
};
</script>
